<template>
  <div v-if="all">
    <v-row>
      <v-col v-for="card in all" :key="`all-${card.id}`" cols="6">
        <v-card class="mt-5" light>
          <v-card-title class="d-flex justify-space-between"
            ><span>{{ card.doc.name }}</span
            ><v-icon class="align-self-start">mdi-account</v-icon></v-card-title
          >
          <v-card-subtitle class="subtitle-2">User Persona</v-card-subtitle>

          <v-card-text class="p1-5">
            <v-row>
              <!-- Core left  -->
              <v-col cols="8">
                <v-row>
                  <v-col
                    cols="6"
                    v-for="field in coreLeft"
                    :key="`text-${field.model}`"
                  >
                    <h3 class="subtitle-2 black--text">{{ field.label }}</h3>
                    <p class="mb-0" v-html="card.doc[field.model]"></p>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="4">
                <v-img
                  :src="card.doc.image"
                  class="preview"
                  v-if="card.doc.image"
                />
              </v-col>
              <!-- Core right  -->
              <v-col cols="8">
                <div v-for="field in coreRight" :key="`text-${field.model}`">
                  <h3 class="subtitle-2 black--text">{{ field.label }}</h3>
                  <template v-if="Array.isArray(card.doc[field.model])">
                    <p
                      v-html="item"
                      v-for="(item, index) in card.doc[field.model]"
                      :key="`text-${card.doc[field.model]}-${index}`"
                      class="mb-1"
                    ></p>
                  </template>
                  <p v-else v-html="card.doc[field.model]"></p>
                </div>
              </v-col>
              <!-- Competenices  -->
              <!-- <v-col cols="12">
                <SaveCanvas>
                  <v-card light color="grey lighten-3">
                    <v-card-title>
                      Competencies
                    </v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          xl="4"
                          v-for="field in competency"
                          :key="`text-${field.model}`"
                        >
                          <h3 class="subtitle-2 ma-0 black--text overline">
                            {{ field.label }}
                          </h3>
                          <v-rating
                            :readonly="true"
                            color="deep-orange"
                            class="ma-0"
                            background-color="grey lighten-1"
                            v-model="card.doc[field.model]"
                          ></v-rating>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </SaveCanvas>
              </v-col> -->
              <!-- Goals  -->
              <v-col cols="7">
                <div v-for="field in goals" :key="`text-${field.model}`">
                  <h3 class="subtitle-2 black--text">{{ field.label }}</h3>
                  <template v-if="Array.isArray(card.doc[field.model])">
                    <p
                      v-html="item"
                      v-for="(item, index) in card.doc[field.model]"
                      :key="`text-${card.doc[field.model]}-${index}`"
                      class="mb-1"
                    ></p>
                  </template>
                  <p v-else v-html="card.doc[field.model]"></p>
                </div>
              </v-col>
              <!-- Ideal world -->
              <v-col cols="5">
                <div v-for="field in end" :key="`text-${field.model}`">
                  <h3 class="subtitle-2 black--text">{{ field.label }}</h3>
                  <p class="text-body-1" v-html="card.doc[field.model]"></p>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import lodash from "lodash";

const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";
// import { SaveCanvas } from "@/components/core";

export default {
  name: "ResultsPropositionUser",
  data() {
    return {
      items: null,
      admins: null,
      users: null,
      all: null,
      coreLeft: [
        {
          label: "Persona",
          model: "persona",
        },
        {
          label: "Gender",
          model: "gender",
        },
        {
          label: "Occupation",
          model: "occupation",
        },
        {
          label: "Location",
          model: "location",
        },
        {
          label: "Age",
          model: "age",
        },
      ],
      coreRight: [
        {
          label: "Description",
          model: "description",
        },
        {
          label: "Interests",
          model: "interests",
        },
        {
          label: "Related websites",
          model: "sites",
        },
      ],
      competency: [
        {
          label: "Internet",
          model: "internet",
        },
        {
          label: "Social Media",
          model: "social",
        },
        {
          label: "Messaging",
          model: "messaging",
        },
        {
          label: "Games",
          model: "games",
        },
        {
          label: "Apps",
          model: "apps",
        },
      ],
      goals: [
        {
          label: "What are their needs?",
          model: "needs",
        },
        {
          label: "What are their goals?",
          model: "theirGoal",
        },
        {
          label: "What are our goals?",
          model: "ourGoal",
        },
        {
          label: "Would could be their frustrations?",
          model: "frustrations",
        },
      ],
      end: [
        {
          label: "In an ideal world we would like...",
          model: "ideal",
        },
      ],
    };
  },
  components: {
    // SaveCanvas,
  },
  props: {
    uid: String,
    id: String,
  },
  watch: {
    uid(val) {
      if (val) {
        this.getExercise();
      }
    },
  },
  mounted() {
    this.getAdmins();
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getAdmins() {
      console.log("admins");
      let ref = fb.profilesCollection.where("webrole", "==", "admin");
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post.uid);
          });
          if (items) {
            this.admins = items;
          }
          this.getExercise();
        })
        .catch(function() {});
    },
    getExercise() {
      console.log("exercise");
      this.doc = null;
      let ref = fb.personaExCollection.where("pid", "==", this.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            // if (!this.admins.some((x) => x == post.uid)) {
            //   items.push(post);
            // }
            items.push(post);
          });
          if (items) {
            this.all = items;
          }
        })
        .catch(function() {});
    },
  },
};
</script>

<style lang="scss">
.preview {
  width: 100%;
  height: auto;
}
</style>
